import { ORDER_STATUSES } from '@cutr/constants/order';

// Generate different objects for working with order status.
const ORDER_STATUS_OPTIONS = Object.freeze(
  ORDER_STATUSES.reduce((result, value, index) => {
    result[value.status] = index;
    return result;
  }, {})
);

const ORDER_STATUS_STRINGS = Object.freeze(
  ORDER_STATUSES.reduce((result, value) => {
    result[value.status] = value.label;
    return result;
  }, {})
);

const ORDER_STATUS_STRINGS_MAKER = Object.freeze(
  ORDER_STATUSES.reduce((result, value) => {
    if (value.maker) result[value.status] = value.label;
    return result;
  }, {})
);

function translateOrderStatus(status, t) {
  if (!status) return status;
  return t(`order:status.${status}`, ORDER_STATUS_STRINGS[status].label);
}
function translateOrderStatusOptions(options, t) {
  return Object.entries(options).reduce((options, [key, label]) => {
    options[key] = t(`order:status.${key}`, label);

    return options;
  }, {});
}

function isDraftOrder(status) {
  return !status || status == 'none' || status == 'draft';
}

export {
  ORDER_STATUS_OPTIONS,
  ORDER_STATUS_STRINGS,
  ORDER_STATUS_STRINGS_MAKER,
  ORDER_STATUSES,
  translateOrderStatus,
  translateOrderStatusOptions,
  isDraftOrder,
};
